import { create } from 'zustand';

export type OverlayId = 'auth' | 'settings' | 'airport';

interface OverlayState {
  /** Стек: Esc и кнопка "назад" закрывают верхний, а не все разом (05 §4). */
  stack: OverlayId[];
  open: (id: OverlayId) => void;
  close: (id?: OverlayId) => void;
  isOpen: (id: OverlayId) => boolean;
}

export const useOverlays = create<OverlayState>((set, get) => ({
  stack: [],
  open: (id) => {
    set((s) => (s.stack.includes(id) ? s : { stack: [...s.stack, id] }));
  },
  close: (id) => {
    set((s) => ({ stack: id ? s.stack.filter((x) => x !== id) : s.stack.slice(0, -1) }));
  },
  isOpen: (id) => get().stack.includes(id),
}));
